<template>
<div class="chapter">
<div class="inner_page">
<h1>The Man Who Hated Mars</h1>
<h1 class="sigil_not_in_toc">And eleven more Stories Vol I</h1>
<h2 class="sigil_not_in_toc">Randall Garrett</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?eab99cb2